<template>
    <form @submit.prevent class="flex items-center">
        <label class="sr-only">Buscar</label>
        <div class="relative w-full">
            <input 
                @input="buscar" 
                type="text" 
                placeholder="Buscar" 
                class="w-72 px-4 py-2 border rounded-lg cursor-text focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
            >
            <span class="absolute right-3 top-2 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </span>
        </div>
    </form>
</template>

<script setup lang="ts">
import { defineEmits } from 'vue';

const emit = defineEmits(['buscar']);

const buscar = (e: Event) => {
    emit('buscar', (e.target as HTMLInputElement).value);
}
</script>

<style scoped>
input::placeholder {
    color: #9CA3AF;
}
</style>